<template>
  <div class="layout-wrapper layout-2">
    <div class="layout-inner">
      <app-layout-sidenav base-path="/zarzadca"  />

      <div class="layout-container">
        <app-layout-navbar />

        <div class="layout-content">
          <div class="router-transitions container-fluid flex-grow-1 container-p-y">
            <router-view />
          </div>

          <app-layout-footer />
        </div>
      </div>
    </div>
    <div class="layout-overlay" @click="closeSidenav"></div>
  </div>
</template>

<script>
import ManagementNavbar from './ManagementNavbar'
import ManagementSidenav from './ManagementSidenav'
import ManagementFooter from './ManagementFooter'

export default {
  name: 'ManagementLayout',
  components: {
    'app-layout-navbar': ManagementNavbar,
    'app-layout-sidenav': ManagementSidenav,
    'app-layout-footer': ManagementFooter
  },

  mounted () {
    this.layoutHelpers.init()
    this.layoutHelpers.update()
    this.layoutHelpers.setAutoUpdate(true)
  },

  beforeDestroy () {
    this.layoutHelpers.destroy()
  },

  methods: {
    closeSidenav () {
      this.layoutHelpers.setCollapsed(true)
    }
  }
}
</script>
